import { Component } from "@angular/core";
import { AbstractHistoryChartOverview } from "src/app/shared/components/chart/abstractHistoryChartOverview";

@Component({
  templateUrl: "./details.overview.html",
})
export class DetailsOverviewComponent extends AbstractHistoryChartOverview { }
